import { AbstractControl, ValidationErrors } from "@angular/forms";

export const houseNumberValidator = (control: AbstractControl): ValidationErrors | null => {
  const houseNumber = control.value;
  return /^[1-9][0-9]{0,4}?$/i.test(houseNumber) ? null : { houseNumber };
};
